import http from "../core/http";
const group = 'dockingRequestReports';

export const getInitialDataRequest = async (data) => {
    return await http.post(`${group}/getInitialData`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getDockingRequestReportRequest = async (data) => {
    return await http.post(`${group}/getReport`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportDockingRequestReportRequest = async (data) => {
    return await http.post(`${group}/export`, data, { responseType: 'blob' }).then(res => res.data).catch(http.defaultCatch);
}

export const getCustomerVesselsRequest = async (data) => {
    return await http.post(`${group}/getCustomerVessels`, data).then(res => res.data).catch(http.defaultCatch);
} 